interface UtilityRowProps {
	children: React.ReactNode;
}

const UtilityRow: React.FC<UtilityRowProps> = ({ children }) => {
	return <div className="flex justify-between mb-5 w-full">{children}</div>;
};

export default UtilityRow;
